import React from 'react';
import PropTypes from 'prop-types';

import { TextDetail } from './components/TextDetail';
import { YoutubeVideoDetail } from './components/YoutubeVideoDetail';

import './style.scss';

const POSITION_DETAILS_NAMES = {
    Description: 'What’s the job?',
    Requirements: 'What are the qualifications?',
};

function Details(props) {
    return (
        <div className="details-section">
            {props.details.map((detail) => (
                <div className="detail-container" key={detail.name}>
                    <h4>{POSITION_DETAILS_NAMES[detail.name] || detail.name}</h4>
                    {!detail.video && <TextDetail detail={detail} />}
                    {detail.video && <YoutubeVideoDetail detail={detail} />}
                </div>
            ))}
        </div>
    );
}

Details.propTypes = {
    details: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
            video: PropTypes.bool,
        })
    ),
};

Details.defaultProps = {
    details: [],
};

export default Details;
